var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.889,
    height: 26,
    viewBox: "0 0 28.889 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_folder_5",
    "data-name": "icon folder 5",
    d: "M30.889,26.111A2.889,2.889,0,0,1,28,29H4.889A2.889,2.889,0,0,1,2,26.111V5.889A2.889,2.889,0,0,1,4.889,3h7.222L15,7.333H28a2.889,2.889,0,0,1,2.889,2.889Z",
    transform: "translate(-2 -3)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSvg);
export default __webpack_public_path__ + "static/media/folder-svg.7170d19b5b562e5ca0c2d4b7b683cb68.svg";
export { ForwardRef as ReactComponent };